module.exports = __webpack_public_path__ + "img/print_logo.320b038d.jpg";